<template>
  <div id="cert_application_infors_submit_outer" v-if="applicationData != null">
    <div style="text-align:center; color: #fc1a34;margin-bottom: 15px;" v-if="errorMsg != null">
      <span>{{errorMsg}}</span>
    </div>
    <div>
      <div class="input-row">
        <div class="column left-label">*姓名：</div>
        <div class="column">
          <el-input :disabled="!isAllowedEditIdNo" v-model="applicationData.name" @change="valueChanged"/>
        </div>
      </div>

<!--      <div class="input-row">-->
<!--        <div class="column left-label">*性别：</div>-->
<!--        <div class="column">-->
<!--          <el-select  placeholder="请选择性别"  v-model="applicationData.sex" @change="valueChanged">-->
<!--            <el-option-->
<!--              v-for="(item, index) in [ '男', '女']"-->
<!--              :key="'sex_' + index"-->
<!--              :label="item"-->
<!--              :value="item"-->
<!--            />-->
<!--          </el-select>-->
<!--        </div>-->
<!--      </div>-->

      <div class="input-row">
        <div class="column left-label">*身高：</div>
        <div class="column">
          <el-input v-model="applicationData.height" @change="valueChanged">
            <template slot="append">CM</template>
          </el-input>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*体重：</div>
        <div class="column">
          <el-input v-model="applicationData.weight" @change="valueChanged">
            <template slot="append">KG</template>
          </el-input>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*服装尺码：</div>
        <div class="column">
          <el-select  placeholder="请选择服装尺码" v-model="applicationData.clothSize" @change="valueChanged">
            <el-option
              v-for="(item, index) in clothSizeList"
              :key="'clothe_size_' + index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*鞋码：</div>
        <div class="column">
          <el-select  placeholder="请选择鞋码" v-model="applicationData.shoeSize" @change="valueChanged">
            <el-option
              v-for="(item, index) in shoeSizeList"
              :key="'show_size_' + index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>

<!--      <div class="input-row">-->
<!--        <div class="column left-label">*证件：</div>-->
<!--        <div class="column">-->
<!--          <el-select  placeholder="请选择证件类别"-->
<!--                      v-model="applicationData.idType"-->
<!--                      :disabled="!isAllowedEditIdNo"-->
<!--                      @change="valueChanged">-->
<!--            <el-option-->
<!--              v-for="(item, index) in ['二代身份证', '护照']"-->
<!--              :key="'id_type_' + index"-->
<!--              :label="item"-->
<!--              :value="item"-->
<!--            />-->
<!--          </el-select>-->
<!--        </div>-->
<!--      </div>-->

      <div class="input-row">
        <div class="column left-label">*身份证号码：</div>
        <div class="column">
          <el-input v-model="applicationData.idNo"
                    :disabled="!isAllowedEditIdNo"
                    placeholder="请输入二代身份证号码"
                    @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*近期免冠照：</div>
        <div class="column">
          <el-upload
            class="files-upload"
            action="https://api.shslqxh.com/upload/files"
            :headers="uploadHeaders"
            name="files"
            accept="image/png, image/jpg"
            :show-file-list="false"
            :on-success="handlePhotoUploadSuccess">
            <el-image v-if="applicationData.photo.length > 0" :src="applicationData.photo" class="avatar user-photo" />
            <i v-else class="el-icon-plus avatar-uploader-icon user-photo-plus"></i>
            <div slot="tip" class="el-upload__tip" style="margin-top: 15px;">请上传本人的近期彩色免冠照片，该照片仅用于资质审核及赛事活动证照、手册等文件的制作，不会用于任何商业行为。</div>
          </el-upload>
        </div>
      </div>

<!--      //englishLevel-->
      <div class="input-row">
        <div class="column left-label">*英语等级：</div>
        <div class="column">
          <el-select  placeholder="请选择英语等级" v-model="applicationData.englishLevel" @change="valueChanged">
            <el-option
              v-for="(item, index) in englishLevelList"
              :key="'english_level_' + index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>
<!--    &lt;!&ndash;      英语等级 其他 补充&ndash;&gt;-->
<!--      <div class="input-row" v-if="applicationData.englishLevel == '其他'" >-->
<!--        <div class="column left-label"></div>-->
<!--        <div class="column">-->
<!--          <el-input v-model="englishDesc" @change="valueChanged"/>-->
<!--        </div>-->
<!--      </div>-->

      <div class="input-row">
        <div class="column left-label">*工作情况：</div>
        <div class="column">
          <el-select  placeholder="请选择工作情况" v-model="applicationData.jobStatus" @change="valueChanged">
            <el-option
              v-for="(item, index) in ['在校学生', '已工作', '已退休']"
              :key="'work_step_' + index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">{{applicationData.jobStatus == '已退休' ? '' : '*'}}所在单位：</div>
        <div class="column">
          <el-input v-model="applicationData.unit" @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*证书类型：</div>
        <div class="column">
          <el-radio v-model="certType" :label="1">裁判员</el-radio>
<!--          <el-radio v-model="applicationData.certType" :label="2">教练员</el-radio>-->
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*证书等级：</div>
        <div class="column">
          <el-select  placeholder="请选择证书等级" v-model="levelIndex" @change="levelValueChanged">
            <el-option
              v-for="(item, index) in levelList"
              :key="'cert_level_' + index"
              :label="item"
              :value="index"
            />
          </el-select>
        </div>
      </div>
      <!--            format="yyyy"-->
      <!--            value-format="yyyy"-->
      <div class="input-row">
        <div class="column left-label">*批准年份：</div>
        <div class="column">
          <el-date-picker
            clearable
            v-model="applicationData.yearOfApproval"
            :picker-options="pickerOptions"
            align="right"
            type="year"
            format="yyyy"
            value-format="yyyy"
            placeholder="选择日期"
            @change="valueChanged"

          >
          </el-date-picker>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*批准单位：</div>
        <div class="column">
          <el-input v-model="applicationData.unitOfApproval" @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*所属区域：</div>
        <div class="column">
          <el-select  placeholder="请选择所属区域" v-model="applicationData.area" @change="valueChanged">
            <el-option
              v-for="(item, index) in areaList"
              :key="'area_select_' + index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">证书编号：</div>
        <div class="column">
          <el-input v-model="applicationData.certificateNo" @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*上传证书照片：</div>
        <div class="column">
          <el-upload
            class="files-upload"
            action="https://api.shslqxh.com/upload/files"
            :headers="uploadHeaders"
            name="files"
            multiple
            :limit="fileLimit"
            :file-list="initialFileList"
            accept="image/png, image/jpg"
            list-type="picture-card"
            :on-exceed="handleExceed"
            :on-remove="handleFileRemove"
            :on-preview="handlePreview"
            :on-success="handleUploadSuccess">
            <i class="el-icon-plus" v-if="fileList.length < fileLimit"></i>
            <div slot="tip" class="el-upload__tip">请上传所有有效信息页，最低需上传两张照片。如证书封面、个人信息页、等级页面、注册记录、工作记录、裁判员卡正反面等。</div>
          </el-upload>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">执裁经历：</div>
        <div class="column">
          <el-input v-model="applicationData.experience" type="textarea" @change="valueChanged"/>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*联系人电话：</div>
        <div class="column">
          <el-input v-model="applicationData.mobile" @change="valueChanged">
            <template slot="append">

              <el-button v-if="timeValue == 0" class="input-right-button-able" @click="codeButtonClicked">获取验证码</el-button>
              <el-button v-else class="input-right-button-disable" disabled>{{timeValue}}s重新获取</el-button>
            </template>
          </el-input>
        </div>
      </div>

      <div class="input-row">
        <div class="column left-label">*短信验证码：</div>
        <div class="column">
          <el-input v-model="applicationData.verificationCode" @change="valueChanged"/>
        </div>
      </div>

<!--
   1. 正常创建身份认证需求，显示'下一步'
   2. 证书过期，重新认证，显示'下一步'
   3. 同一身份认证过程中，产生的等待，显示'重新提交'
   -->
      <div style="text-align: center;">
        <span style="margin-top: 40px;display: block;font-size: smaller;color: #777;">请仔细核对信息，一旦点击”提交信息“则不能对本页面进行修改。</span>
        <el-button class="next-button" @click="nextButtonClicked" round>提交信息</el-button>
      </div>

    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageurl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "CertApplicationInforsSubmitVue",
  props: {
    judge: {
      default: () => null
    }
  },
  data() {
    return {
      timeValue: 0,
      isEdited: false,
      timerFlag: null,
      uploadHeaders: {},
      fileLimit: 10,
      initialFileList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageurl: '',
      errorMsg: null,
      pickerOptions: {
        disabledDate: (time) => {
          return this.dealDisableDate(time);
        }
      },
      isAllowedEditIdNo: true,
      levelIndex: null,
      levelList: [
        '国际级',
        '三人篮球国际级',
        '国家级',
        '荣誉裁判员',
        '一级',
      ],

      englishLevelList: ['大学六级及以上', '大学六级以下'],
      areaList: [
        '黄浦区',
        '静安区',
        '长宁区',
        '普陀区',
        '虹口区',
        '杨浦区',
        '浦东新区',
        '闵行区',
        '徐汇区',
        '宝山区',
        '嘉定区',
        '金山区',
        '松江区',
        '青浦区',
        '奉贤区',
        '崇明区',
        '学生体协',
        '上海体院',
        '其他行业体协'
      ],
      clothSizeList: [
        'S',
        'M',
        'L',
        'XL',
        '2XL',
        '3XL',
        '4XL',
        '5XL',
        '6XL及以上'
      ],
      shoeSizeList: [],
      certType: 1,
      englishDesc: '',
      zeroJudgeData:  {
        // sex: '男',
        clothSize: '',
        shoeSize: '',
        name: '',
        photo: '',
        height: '',
        weight: '',
        // idType: '',
        idNo: '',
        englishLevel: '',
        jobStatus: '',
        unit: '',
        certificateLevel: '',
        certificateType: -1,
        yearOfApproval: null,
        unitOfApproval: '',
        area: '',
        certificateNo: '',
        certificatePhoto: '',
        mobile: '',
        verificationCode: '',
        experience: '',
      },
      applicationData: null,
      judgeInfors: null,
    }
  },

  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    yearOfApproval() {
      let dateOfApproval = this.applicationData.yearOfApproval;
      if (dateOfApproval == null) {
        return null;
      }
      if ((typeof dateOfApproval) == 'string') {
        return dateOfApproval;
      }
      return  dateOfApproval.getFullYear();
    },


    user() {
      return this.$store.state.user;
    },
  },

  destroyed() {
    this.clearTimeFlag();
  },
  mounted() {
    this.uploadHeaders.token = this.$store.state.dataStore.getToken();
    this.initShoeSizeList();
    this.initJudgeInforsData();
    this.insertJudgeFromOldJudge();
    this.updateWithUserDate();
    this.updateVerificationCode();
    this.configErrorMsg();
  },
  methods: {
    configErrorMsg() {
      let idErrorRemark = this.$store.state.idErrorRemark;
      if (idErrorRemark != null) {
        this.errorMsg = idErrorRemark;
        this.$store.commit('setIdErrorRemark', null);
      } else {
        let judge = this.judge;
        if (judge != null && (judge.status == 7 || judge.status == 8) && judge.auditRemark != null && judge.auditRemark != '') {
          this.errorMsg = judge.auditRemark;
        }
      }
    },

    updateVerificationCode() {
      let dataStore = this.$store.state.dataStore;
      let verifyCode = dataStore.getPhoneVerifyCode();
      if (verifyCode != null) {
        this.applicationData.verificationCode = verifyCode;
      }
    },

    updateWithUserDate() {
      let user = this.user;
      if (user == null) {
        let _this = this;
        setTimeout(function () {
          _this.updateWithUserDate();
        }, 50);
        return;
      }

      if (this.isAllowedEditIdNo) {
        let name = user.name;
        let idNumber = user.idNumber;
        let isIdentification = user.isIdentification;
        if (isIdentification > 0) {
          if (name != null && idNumber != null && name.length > 0 && idNumber.length > 0) {
            this.judgeInfors.idNo = idNumber;
            this.judgeInfors.name = name;
            this.applicationData.idNo = idNumber;
            this.applicationData.name = name;
            this.isAllowedEditIdNo = false;
          }
        }
      }
    },
    initShoeSizeList() {
      for (let i = 34; i < 61; i++) {
        let sizeItem = i + '';
        this.shoeSizeList.push(sizeItem);
        if (i < 60) {
          let halfSizeItem = (i + 0.5) + '';
          this.shoeSizeList.push(halfSizeItem);
        }
      }
      // this.shoeSizeList.push('50以上');
    },
    insertJudgeFromOldJudge() {
      let judgeList = this.$store.state.judgeList;
      if (judgeList == null) {
        let _this = this;
        setTimeout(function () {
          _this.insertJudgeFromOldJudge();
        }, 500);
        return;
      }
      // let idType = null;
      let idNo = null;
      let name = null;
      if (judgeList.length > 0) {
        for (let i = 0; i < judgeList.length; i++) {
          let item = judgeList[i];
          if (item.status >= 2 && item.status <= 7) {
            idNo = item.idNo;
            name = item.name;
            break;
          }
        }

       if (idNo != null) {
         this.judgeInfors.idNo = idNo;
         this.judgeInfors.name = name;
         this.applicationData.idNo = idNo;
         this.applicationData.name = name;
         this.isAllowedEditIdNo = false;
       }
      }
    },
    initJudgeInforsData() {
      let yearOfApproval = this.zeroJudgeData.yearOfApproval;
      if (yearOfApproval == null) {
        let now = new Date();
        this.zeroJudgeData.yearOfApproval = now.getFullYear();
      }
      let judgeData = this.judge;
      this.judgeInfors = {};
      if (judgeData == null) {
        let tmpData = {};
        for (let key in this.zeroJudgeData) {
          let value = this.zeroJudgeData[key];
          this.judgeInfors[key] = value;
          if (key == 'yearOfApproval') {
            let dateStr = value + '-01-01';
            let yearDate = new Date(dateStr);
            tmpData[key] = yearDate;
          } else {
            tmpData[key] = value;
          }
        }
        // this.englishDesc = '';
        this.applicationData = tmpData;
        this.updateWithUserDate();
      } else {
        let tmpData = {};
        for (let key in this.zeroJudgeData) {
          let value = judgeData[key];
          this.judgeInfors[key] = value;

          if (key == 'yearOfApproval') {
            let dateStr = value + '-01-01';
            let yearDate = new Date(dateStr);
            tmpData[key] = yearDate;
          } else {
            if (value == null) {
              value = '';
            }

            if ((typeof  value) != 'string') {
              value = value + '';
            }


            // if (key == 'englishLevel') {
            //   if (value == '') {
            //     tmpData[key] = value;
            //     continue;
            //   }
            //   let index = this.englishLevelList.indexOf(value);
            //   if (index >= 0) {
            //     tmpData[key] = value;
            //     continue;
            //   }
            //   tmpData[key] = this.englishLevelList[this.englishLevelList.length - 1];
            //   this.englishDesc = value;
            //   continue;
            // }
            tmpData[key] = value;
          }
        }
        let certificateLevel = tmpData.certificateLevel;

        let levelIndex = this.levelList.findIndex(function(item) {
          return certificateLevel == item;
        });
        if (levelIndex == -1) {
          this.levelIndex = null;
          tmpData.certificateLevel = '';
          tmpData.certificateType = -1;
        } else {
          this.levelIndex = levelIndex;
          tmpData.certificateType = this.getCertificateTypeFromLevel(levelIndex);
        }

        this.applicationData = tmpData;
        this.initFileList(this.applicationData.certificatePhoto);
      }
    },
    initFileList(certificatePhoto) {
      if (certificatePhoto == null || certificatePhoto == '') {
        return;
      }
      let tmpArray = certificatePhoto.split(',');
      for (let i = 0; i < tmpArray.length; i++) {
        let imageUrl = tmpArray[i];
        if (imageUrl.length > 0) {
          let item = {
            name: 'image_' + i,
            url: imageUrl
          };
          this.fileList.push(item);
          this.initialFileList.push(item);
        }
      }
    },
    levelValueChanged() {
      let levelIndex = this.levelIndex;
      if (levelIndex == null) {
        this.applicationData.certificateLevel = '';
        return;
      }
      let level = this.levelList[levelIndex];
      this.applicationData.certificateLevel = level;
      this.applicationData.certificateType = this.getCertificateTypeFromLevel(levelIndex);
      this.valueChanged();
    },
    valueChanged() {
      let isEdit = false;
      for (let key in this.judgeInfors) {
        if (key == 'verificationCode') {
          continue;
        }

        let initialValue = this.judgeInfors[key];
        let value = initialValue;

        // if (key == 'englishLevel') {
        //   value = this.applicationData[key].removeBlanks();
        //   if (value == '其他') {
        //     value = this.englishDesc;
        //   }
        //   if (initialValue != value) {
        //     isEdit = true;
        //     break;
        //   }
        //   continue;
        // }

        if (key == 'yearOfApproval') {
          value = this.applicationData[key];
          if (typeof value == 'object') {
            value = value.getFullYear();
          }
          if (value != initialValue) {
            isEdit = true;
            break;
          }
          continue;
        }

        if (key == 'name' || key == 'experience') {
          let value = this.applicationData[key].removeNamesBlank();
        } else {
          value = this.applicationData[key];
          if (typeof value == 'string') {
            value = value.removeBlanks();
          }
        }
        if (value != initialValue) {
          isEdit = true;
          break
        }
      }
      let storedEditing = !this.$store.state.allowedLeave;
      this.isEdited = isEdit;
      if (storedEditing != isEdit) {
        this.$store.commit('isAllowedLeave', !isEdit);
      }
    },
    dealDisableDate(time) {
      return new Date().getTime() - (new Date(time).getTime()) < 0;
    },
    beforeRemoveFile(file, fileList) {
      return this.$confirm(`确定移除${ file.name }吗？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${ this.fileLimit } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleFileRemove(file ,fileList) {
      let url = file.response;
      let index = this.fileList.findIndex(function (item) {
        return item.url == url;
      });
      this.fileList.splice(index, 1);
      this.updateCertificatePhoto();
      this.valueChanged();
    },
    handlePreview(file) {
      let url = file.response;
      this.dialogImageurl = url;
      this.dialogVisible = true;
    },
    handleUploadSuccess(res, file) {
      if (typeof res == 'string') {
        let name = file.name;
        let url = res;
        let obj = {
          name,
          url
        };
        this.fileList.push(obj);
        this.updateCertificatePhoto();
        this.valueChanged();
      }
    },


    beforePhotoRemoveFile(file, fileList) {
      // return this.$confirm(`确定移除${ file.name }吗？`);
    },
    handlePhotoExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${ 1 } 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handlePhotoRemove(file ,fileList) {
      let url = file.response;
      this.applicationData.photo = '';
      this.valueChanged();
    },
    handlePhotoPreview(file) {
      let url = file.response;
      this.dialogImageurl = url;
      this.dialogVisible = true;
    },

    handlePhotoUploadSuccess(res, file) {
      if (typeof res == 'string') {
        let url = res;
        this.applicationData.photo = url;
        this.valueChanged();
      }
    },


    updateCertificatePhoto() {
      let fileList = this.fileList;
      let tmp = '';
      if (fileList.length > 0) {
        for (let i = 0; i < fileList.length; i++) {
          let image = fileList[i];
          tmp += image.url;
          if (i < fileList.length - 1) {
            tmp += ',';
          }
        }
      }
      this.applicationData.certificatePhoto = tmp;
    },

    codeButtonClicked() {
      let mobile = this.applicationData.mobile.removeBlanks();
      if (mobile == '') {
        this.$toast('请输入联系人手机号！');
        return;
      }

      if (!mobile.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let params = {
        phoneNumbers: mobile,
        tag: 'SMS_235495231',
      };
      let _this = this;
      this.requestLoading = true;
      this.httpManager.ajax.smsSend(params, function (data) {
        _this.requestLoading = false;
        if (data.code == 0) {
          _this.timeValue = 60;
          _this.timerFlag = setInterval(_this.codeSecondOperate, 1000);
          return;
        }
        _this.$toast('发送失败！');
      }, function (data) {
        _this.requestLoading = false;
        _this.$toast('发送失败，请重试！');
      });
    },

    codeSecondOperate() {
      this.timeValue --;
      if (this.timeValue <= 0) {
        this.clearTimeFlag();
      }
    },
    clearTimeFlag() {
      if (this.timerFlag != null) {
        clearInterval(this.timerFlag);
        this.timerFlag = null;
        this.timeValue = 0;
      }
    },
    showToast(msg) {
      this.$toast(msg);

    },

    getCertificateTypeFromLevel(levelIndex) {
      if (levelIndex == null) {
        return -1;
      }
      let showIndex = -2;
      switch (levelIndex) {
        case 0:
          showIndex = 1;
          break;
        case 1:
          showIndex = 2;
          break;
        case 2:
          showIndex = 3;
          break;
        case 3:
          showIndex = 4;
          break;
        case 4:
          showIndex = 5;
          break;
        default:
          showIndex = -2;
      }
      return showIndex;
    },

    nextButtonClicked() {
      let params = null;
      if (this.judge != null) {
        params = this.judge;
        // params.status = 1;


        if (params.auditStatus == 0) {
          params.status = 1;
        } else {
          if (params.status == null || params.status == 0) {
            params.status = 1;
          }
          if (params.status == 6) {
            params.status = 1;
          } else if (params.status == 1) {
            params.status = 1;
          } else if (params.status == 7) {
            params.status = 4;
          }
        }


      } else {
        params = {};
      }

      let applicationData = this.applicationData;
      let name = applicationData.name.removeNamesBlank();
      if (name == '') {
        this.showToast('请输入姓名！');
        return;
      }
      params.name = name;

      let height = applicationData.height.removeBlanks();
      if (height == '') {
        this.showToast('请输入身高！');
        return;
      }
      params.height = height;

      let weight = applicationData.weight.removeBlanks();
      if (weight == '') {
        this.showToast('请输入体重！');
        return;
      }
      params.weight = weight;

      let clothSize = applicationData.clothSize;
      if (clothSize == '') {
        this.showToast('请选择服装尺码！');
        return;
      }
      params.clothSize = clothSize;

      let shoeSize = applicationData.shoeSize;
      if (shoeSize == '') {
        this.showToast('请选择鞋码！');
        return;
      }
      params.shoeSize = shoeSize;

      // let idType = applicationData.idType;
      // if (idType == '') {
      //   this.showToast('请选择证件类别！');
      //   return;
      // }
      // params.idType = idType;

      let idNo = applicationData.idNo.removeBlanks();
      if (idNo == '') {
        this.showToast('请输入二代身份证号码！');
        return;
      }

      if (idNo.length < 18 || !idNo.isIdCard()) {
        this.showToast("请输入正确的二代身份证号码！");
        return;
      }

      params.idNo = idNo;
      let sex = idNo.getSexFromIdCard();
      params.sex = sex;

      let photo = applicationData.photo.removeBlanks();
      if (photo == '') {
        this.showToast('请上传近期免冠照片！');
        return;
      }
      params.photo = photo;

      let englishLevel = applicationData.englishLevel;
      if (englishLevel == '') {
        this.showToast('请选择英语等级！');
        return;
      }

      // if (englishLevel == '其他') {
      //   englishLevel = this.englishDesc.removeBlanks();
      //   if (englishLevel == '') {
      //     this.showToast('请输入您的英语等级！');
      //     return;
      //   }
      // }

      params.englishLevel = englishLevel;

      let jobStatus = applicationData.jobStatus;
      if (jobStatus == '') {
        this.showToast('请选择工作情况！');
        return;
      }
      params.jobStatus = jobStatus;

      let unit = applicationData.unit.removeBlanks();
      if (unit == '' && jobStatus != '已退休') {
        this.showToast('请输入所在单位！');
        return;
      }
      params.unit = unit;

      let certificateLevel = applicationData.certificateLevel;
      if (certificateLevel == '') {
        this.showToast('请选择证书等级！');
        return;
      }
      params.certificateLevel = certificateLevel;
      params.certificateType = applicationData.certificateType;

      let yearOfApproval = this.yearOfApproval;
      if (typeof this.yearOfApproval == 'object') {
        yearOfApproval = yearOfApproval.getFullYear();
      }

      if (yearOfApproval == null) {
        this.showToast('请选择批准年份！');
        return;
      }
      params.yearOfApproval = yearOfApproval;

      let unitOfApproval = applicationData.unitOfApproval.removeBlanks();
      if (unitOfApproval == '') {
        this.showToast('请输入批准单位！');
        return;
      }
      params.unitOfApproval = unitOfApproval;

      let area = applicationData.area;
      if (area == '') {
        this.showToast('请选择所属区域！');
        return;
      }
      params.area = area;

      let certificateNo = applicationData.certificateNo.removeBlanks();
      // if (certificateNo == '') {
      //   this.showToast('请输入证书编号！');
      //   return;
      // }
      params.certificateNo = certificateNo;

      let certificatePhoto = applicationData.certificatePhoto;
      if (certificatePhoto == '') {
        this.showToast('请上传证书照片！');
        return;
      }

      if (this.fileList.length < 2) {
        this.showToast('证书照片上传数量不得低于两张！');
        return;
      }

      params.certificatePhoto = certificatePhoto;

      let experience = applicationData.experience.removeNamesBlank();
      params.experience = experience;

      let mobile = applicationData.mobile.removeBlanks();
      if (mobile == '') {
        this.showToast('请输入手机号！');
        return;
      }
      if (!mobile.isPhoneNumber()) {
        this.showToast('联系人手机号不正确！');
        return;
      }
      params.mobile = mobile;

      let verificationCode = applicationData.verificationCode.removeBlanks();
      if (verificationCode == '') {
        this.$toast('请输入短信验证码！');
        return;
      }
      params.verificationCode = verificationCode;
      this.submitInfors(params);
    },

    postModifiedData(params, success) {
      this.httpManager.ajax.postJudgeModifiedData(params, success, function (data) {});
    },

    submitInfors(params) {
      if (params.userId == undefined || params == null) {
        let user = this.user;
        if (user == null) {
          this.$toast('没有用户信息');
          return;
        }
        let userId = user.id;
        params.userId = userId;
      }
      params.auditStatus = 1;
      // console.log(params);
      // return;
      let _this = this;
      this.httpManager.ajax.postJudgeEditData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          let judgeId = data.data;
          _this.$store.state.dataStore.setPhoneVerifyCode(params.verificationCode);
          let modifiedParams = {
            id: judgeId,
          };

          if (_this.isEdited) {
            modifiedParams.modified = 1;
          } else {
            modifiedParams.modified = 0;
          }
          // console.log(modifiedParams);
          _this.postModifiedData(modifiedParams, function (data) {
            let code = data.code;
            if (code == 0) {
              _this.isEdited = false;
              _this.$toast("提交成功！");
              _this.$store.commit('isAllowedLeave', true);
              setTimeout(function () {
                _this.$emit("informationSubmitSuccess", {
                  id: judgeId
                });
              },1000);
            }
          });
          return;
        }
        if (code == 2) {
          _this.$toast("验证码不正确！");
          return;
        }
        _this.$toast("信息提交失败！");
      }, function (data) {
        _this.$toast('信息提交失败，请重试！');
      });
    }
  }
}
</script>

<style scoped>
  #cert_application_infors_submit_outer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: nowrap;
  }

  #cert_application_infors_submit_outer > div {
    width: 100%;
  }

  #cert_application_infors_submit_outer .el-select {
    width: 100%;
  }

  #cert_application_infors_submit_outer .input-row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin-bottom: 15px;
  }

  #cert_application_infors_submit_outer .input-row:last-child {
    margin-bottom: 0;
  }

  #cert_application_infors_submit_outer .input-row > .column:first-child {
    width: 30%;
    text-align: right;
    padding-right: 15px;
  }

  #cert_application_infors_submit_outer .input-row > .column:not(:first-child) {
    width: 70%;
  }

  #cert_application_infors_submit_outer .left-label {
    font-size: small;
  }

  .files-upload {
    margin-top: 15px;
    text-align: left;
  }

  #cert_application_infors_submit_outer .files-upload /deep/ .el-upload-list__item, #cert_application_infors_submit_outer .files-upload /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }
  #cert_application_infors_submit_outer .files-upload /deep/ .el-upload--picture-card {
    line-height: 100px;
  }

  #cert_application_infors_submit_outer .files-upload /deep/ input[type='file'] {
    display: none;
  }

  #cert_application_infors_submit_outer .files-upload /deep/ .el-button {
    background-color: #fc1a34;
    color: white;
    border: none;
    margin-top: 10px;
  }

  #cert_application_infors_submit_outer .el-input-group__append .el-button {
    margin: -9px -20px;
    border-radius: 0;
  }

  #cert_application_infors_submit_outer .input-right-button-able {
    background-color: #fc1a34;
    color: white;
  }

  #cert_application_infors_submit_outer .input-right-button-disable {
    background-color: lightgrey;
    color: white;
  }

  #cert_application_infors_submit_outer .next-button {
    background-color: #fc1a34;
    border-color: #fc1a34;
    width: 90%;
    max-width: 300px;
    padding-left: 0;
    padding-right: 0;
    color: white;
    margin-top: 10px;
    margin-bottom: 20px;
  }

  #cert_application_infors_submit_outer /deep/ .el-input__inner:focus, #cert_application_infors_submit_outer /deep/ .el-textarea__inner:focus {
    border: solid 1px #fc1a34;
  }

  #cert_application_infors_submit_outer  /deep/ .el-radio .el-radio__input .el-radio__inner:hover {
    border-color: #fc1a34;
  }

  #cert_application_infors_submit_outer  /deep/ .el-radio.is-checked .el-radio__input .el-radio__inner {
    border-color: #fc1a34;
    background-color: #fc1a34;
  }
  #cert_application_infors_submit_outer  /deep/ .el-radio.is-checked .el-radio__label {
    color: #fc1a34;
  }

  #cert_application_infors_submit_outer .user-photo-plus {
    width: 140px;
    height: 140px;
    border: solid 1px lightgrey;
    line-height: 140px;
    text-align: center;
    font-size: 3rem;
    color: gray;
  }

  #cert_application_infors_submit_outer .user-photo {
    max-width: 140px;
    max-height: 140px;
  }


  @media screen and (min-width: 768px){
    #cert_application_infors_submit_outer > div {
      max-width: 700px;
    }

    #cert_application_infors_submit_outer .left-label {
      font-size: 1rem;
    }

    #cert_application_infors_submit_outer .files-upload /deep/ .el-upload-list__item, #cert_application_infors_submit_outer .files-upload /deep/ .el-upload--picture-card {
      width: 140px;
      height: 140px;
    }

    #cert_application_infors_submit_outer .files-upload /deep/ .el-upload--picture-card {
      line-height: 140px;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/certificates/application/CertApplicationInforsSubmitVue.vue